import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import SelectDropDown from '../../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import moment from "moment";


const ADD_FEE = gql`
  mutation($params: StudentFees) {
    addStudentFees(params: $params)
  }`

class FeeSetupSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultvalue:0,
            branch: "",
            branchError: "",

            class: "",
            classError: "",

            exam: "",
            examError: "",

            amount: "",
            amountError: "",

            feeType: "",
            feetypeError: "",

            section: "",
            sectionError: "",

            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,

            getClassWiseFeeData: [],
            getExams: [],
            getClasses: [],
            getSections: [],

        }
    }

    componentDidMount() {
        this.getClassWiseFeeData()
    }

    Columns(data) {

        let Columns = [
            {
                dataField: "branch_name",
                text: "Branch",
                sort: true
            },
            {
                dataField: "class_name",
                text: "Class",
            },
            {
                dataField: "exam_name",
                text: "Exam",
            },
            {
                dataField: "section_name",
                text: "Section",
            },
            {
                dataField: "fee_type_name",
                text: "Fee Type",
            },
            {
                dataField: "fee",
                text: "Fees",
                sort: true
            },
        ];
        return Columns;
    }


    handleInputChange = e => {

        const name = e.target.name;
        const value = e.target.value;

        let getArray = [];

        if (name == "branch") {
            if (value != "0") {

                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch: value,
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    amount: "",
                    amountError: "",
                    getExams: getArray,
                    getClasses: [],
                    getSections: [],
                    submitError:""
                })

            } else {

                this.setState({
                    branch: "",
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    amount: "",
                    amountError: "",
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    submitError:""
                })
            }
        }

        if (name == "exam") {

            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "",
                    exam: value,
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    amount: "",
                    amountError: "",
                    getClasses: getArray,
                    getSections: [],
                    submitError:""
                })
            } else {
                this.setState({
                    branchError: "",
                    exam: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    amount: "",
                    amountError: "",
                    getClasses: [],
                    getSections: [],
                    submitError:""
                })

            }
        }


        if (name == "class") {

            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == this.state.exam && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                let sections = getArray.map((item) => item.value).toString();

                this.setState({
                    branchError: "",
                    examError: "",
                    class: value,
                    classError: "",
                    section: "",
                    sectionError: "",
                    amount: "",
                    amountError: "",
                    getSections: getArray,
                    submitError:""
                })

            } else {

                this.setState({
                    branchError: "",
                    examError: "",
                    class: "",
                    classError: "",
                    section: "",
                    sectionError: "",
                    amount: "",
                    amountError: "",
                    getSections: [],
                    submitError:""
                })

            }

        }

        
        if (name == "section") {
            if (value != "0") {
                this.setState({
                    section: value,
                    sectionError: "",
                    submitError:""
                })
            }else{
                this.setState({
                    section: "",
                    sectionError: "",
                    submitError:""
                })  
            }
        }
    
    };

    handleFeesChange = (e) => {
        const value = e.target.value;
        const name = e.target.name;

        if (name == "fees") {
            if (value < 0) {
                this.setState({ amountError: "Please enter valid amount" })
            } else {
                this.setState({ amount: value, amountError: "" })
            }
        }
    }

    getClassWiseFeeData = async () => {
        this.setState({ loader: 1 })
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int){
                getClassWiseFeeData(institute_id:$institute_id){
                    class_name
                    fee_type_name
                    branch_name
                    fee
                    exam_name
                    section_name
                  }
            }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getClassWiseFeeData.length > 0) {
            this.setState({ getClassWiseFeeData: result.data.getClassWiseFeeData, loader: 0 })
        } else {
            this.setState({ getClassWiseFeeData: [], loader: 0 })
        }

    }

    handleFormSubmit = e => {
        if (this.state.branch == "") {
            this.setState({ branchError: "Please select branch" })
            return ""
        }
        if (this.state.exam == "") {
            this.setState({ examError: "Please select exam" })
            return ""
        }
        if (this.state.class == "") {
            this.setState({ classError: "Please select class" })
            return ""
        }
        if (this.state.section == "") {
            this.setState({ sectionError: "Please select section" })
            return ""
        }
        if (this.state.amount == "" || this.state.amount == "0") {
            this.setState({ amountError: "Please enter valid amount" })
            return ""
        }

        let params = {
            class_id: parseInt(this.state.class),
            branch_id: parseInt(this.state.branch),
            institute_id: parseInt(Cookies.get("institutionid")),
            exam_id: parseInt(this.state.exam),
            fee_amount: parseInt(this.state.amount),
            fee_type_id: 1,
            section_id: parseInt(this.state.section)
        }

        this.addStudentFees(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message) })
            console.error(
                "ERR =>",
                error.graphQLErrors.map(x => x.message)
            );
            setTimeout(() => {
            }, 5000);
        })
    }

    addStudentFees = async params => {
        console.log("child");
        await this.props.addStudentFees({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addStudentFees) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });

                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };
    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        window.location.reload(false);
    };

    render() {
        console.log("mahesh",this.state);

        let sections = [];
        if (this.state.exam != "") {
            this.props.globals.globalPackages.map((item) => {
                if (item.exams_covered == this.state.exam) {
                    this.props.globals.globalCategories.map((stumap) => {
                        if (stumap.package_id == item.id) {
                            this.props.globals.globalSections.map((stumap1) => {
                                if (stumap1.category_id == stumap.id) {
                                    const newObj = {
                                        id: stumap1.id,
                                        section_name: stumap1.section_name
                                    }
                                    sections.push(newObj);
                                }
                            })
                        }
                    });
                }
            });
        }

        return (
            <Container>
                <Row className="mt-3">
                     <Col>
                        <h4>Create Tution Fee</h4>
                     </Col>
                </Row>
                <Row className="mt-3">
                    <Col sm={12}>
                        <Form>
                            <Form.Row>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Branch</Form.Label>
                                    <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch}>
                                        <option value={this.state.defaultvalue}>--Select Branch--</option>
                                        {this.props.globals.globalBranches.map(branchData => (
                                            <option value={branchData.id}>{branchData.branch_name}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.branchError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Form.Label className="text-uppercase">Exam</Form.Label>
                                    <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam}>
                                        <option value={this.state.defaultvalue}>--Select Exam--</option>
                                        {this.state.getExams.map(item => (
                                            <option value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.examError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                    <Form.Label className="text-uppercase">Class</Form.Label>
                                    <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class}>
                                        <option value={this.state.defaultvalue}>--Select class--</option>
                                        {this.state.getClasses.map(classdata => (
                                            <option value={classdata.value}>{classdata.label}</option>
                                        ))}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.classError}
                                    </Form.Text>
                                </Form.Group>

                     

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectSection"  >
                                    <Form.Label className="text-uppercase">Section</Form.Label>
                                    <Form.Control as="select" name="section" onChange={this.handleInputChange} value={this.state.section}>
                                        <option value={this.state.defaultvalue}>--Select Section--</option>
                                        {this.state.getSections.map(sectiondata => (
                                            <option value={sectiondata.value}>
                                                {sectiondata.label}
                                            </option>)
                                        )}
                                    </Form.Control>
                                    <Form.Text className="form-text text-danger">
                                        {this.state.sectionError}
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Form.Label className="text-uppercase">Amount</Form.Label>
                                    <input
                                        type="number"
                                        name="fees"
                                        value={this.state.amount}
                                        placeholder="Enter Amount"
                                        onChange={this.handleFeesChange}
                                        className="custom_box"
                                    />
                                    <Form.Text className="form-text text-danger">
                                        {this.state.amountError}
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                    <Button className="btn btn-success text-uppercase submit_btn" onClick={(e) => this.handleFormSubmit()}>Create</Button>
                                </Form.Group>
                            </Form.Row>

                            <Form.Row>
                                <Form.Group as={Col} lg={9} md={12} sm={12} controlId="Selectexam">
                                    {this.state.currentStep == 5 ? (
                                        <h6 className="text-center form-text text-danger mb-2 ">
                                            Fee Data Saved successfully
                                        </h6>
                                    ) : (
                                        <h6 className="text-center form-text text-danger">{this.state.submitError}</h6>
                                    )}
                                </Form.Group>
                            </Form.Row>
                        </Form>
                    </Col>
                </Row>
                {
                    this.state.getClassWiseFeeData.length > 0 ?
                        (
                            <>
                                <Row className="">
                                    <Col sm={12}>
                                        <h3 className="text-center">Tution Fee List</h3>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col sm={12}>
                                        <CardLessDataTableWithOutSearch
                                            parentData={this.state.getClassWiseFeeData}
                                            particlecolumns={this.Columns()}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                        :
                        (
                            this.state.loader == 1 ?
                                (
                                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                                )
                                :
                                ("")
                        )
                }

            </Container>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_FEE, {
        name: "addStudentFees"
    })
)(FeeSetupSection))
);